import * as Styles from './styles'

type Props = {
  isCompleted?: boolean
  text: {
    badge?: string
    header: string
    subHeader: string
    actionText?: string
  }
  children?: React.ReactNode | React.ReactNode[]
  handleClick?: () => void
}
export const InfoBox = ({ isCompleted, text, children, handleClick }: Props) => {
  return (
    <Styles.Container>
      {!isCompleted && (
        <Styles.Badge>
          <Styles.BadgeText>{text.badge}</Styles.BadgeText>
        </Styles.Badge>
      )}
      <Styles.TextContainer>
        <Styles.Header>{text.header}</Styles.Header>
        <Styles.SubHeader>{text.subHeader}</Styles.SubHeader>
      </Styles.TextContainer>
      <Styles.ActionContainer>
        {children || (
          <Styles.ButtonContainer onClick={handleClick}>
            <Styles.ActionText>{text.actionText}</Styles.ActionText>
            <Styles.IconContainer>
              <Styles.Icon />
            </Styles.IconContainer>
          </Styles.ButtonContainer>
        )}
      </Styles.ActionContainer>
    </Styles.Container>
  )
}
